export const rulesLink = 'https://soundstudios.io/rules';
export const termsLink = 'https://soundstudios.io/terms-and-conditions';
